<template>
  <div class="interview-date-select">
    <van-field
      v-model="value"
      readonly
      class="field-select"
      :class="[disabled && 'is-disabled', error && 'is-error']"
      :border="false"
      @click="handleShowPopup"
    >
      <template #left-icon>
        <slot name="leftIcon"></slot>
      </template>
      <template #right-icon>
        <van-icon class="el-icon-arrow-down" />
      </template>
    </van-field>
    <van-calendar v-if="dateType === 'calendar'" v-model="showPopup" color="#0096cc" :show-confirm="false" @confirm="handleSelect" />
    <van-popup
      v-else
      round
      v-model="showPopup"
      position="bottom"
      class="select-popup"
    >
      <van-picker
        v-if="dateType === 'time'"
        v-bind="dateTimeProps"
        show-toolbar
        ref="timePicker"
        class="time-picker"
        :title="dateTimeProps.title"
        :confirm-button-text="$t('common.btn.confirm')"
        :cancel-button-text="$t('common.btn.cancel')"
        @change="handleTimeChange"
        @confirm="handleSelect"
        @cancel="handleTimeCancel"
      />
    </van-popup>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'

export default {
  props: {
    value: {
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    dateType: {
      type: String,
      default: 'calendar'
    },
    dateTimeProps: {
      type: Object,
      default: () => ({})
    },
    events: {
      type: Object,
      default: () => ({})
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data () {
    return {
      showPopup: false,
      selectValue: null
    }
  },
  computed: {
  },
  methods: {
    async handleShowPopup () {
      if (this.disabled) {
        return
      }
      this.selectValue = this.formatterValue(this.value)
      this.showPopup = true
      if (this.dateType === 'time') {
        await this.resetTimePicker()
      }
    },
    handleSelect (date) {
      const formatterValue = this.formatterValue(date)
      this.showPopup = false
      this.$emit('change', formatterValue)
    },
    formatterValue (value) {
      let formatterValue = value
      if (this.events?.formatterValue) {
        formatterValue = this.events.formatterValue(value)
      } else if (this.dateType === 'calendar') {
        formatterValue = moment(value).format('YYYY-MM-DD')
      } else if (this.dateType === 'time') {
        formatterValue = moment(value, 'HH:mm').format('HH:mm')
      }
      return formatterValue
    },
    handleTimeChange (picker, values) {
      if (this.events?.handleTimeChange) {
        this.events.handleTimeChange(picker, values)
      }
    },
    handleTimeCancel () {
      this.showPopup = false
    },
    async resetTimePicker () {
      let timePickerRef = this.$refs.timePicker
      if (!timePickerRef) {
        await this.$nextTick()
        timePickerRef = this.$refs.timePicker
      }
      const selectHour = this.selectValue.split(':')[0]
      const selectMinute = this.selectValue.split(':')[1]
      const hourOptions = timePickerRef.getColumnValues(0)
      const minuteOptions = timePickerRef.getColumnValues(1)
      timePickerRef.setColumnIndex(0, _.indexOf(hourOptions, selectHour))
      timePickerRef.setColumnIndex(1, _.indexOf(minuteOptions, selectMinute))
    }
  }
}
</script>

<style scoped lang="scss">
.interview-date-select {
  .field-select {
    padding: 4px 10px 4px 8px;
    border-radius: 4px;
    border: 1px solid rgba(194, 197, 203, 0.3);
    line-height: 20px;

    &.is-disabled {
      background-color: #f2f2f2;

      ::v-deep {
        .van-field__control {
          color: #666;
        }
      }
    }

    &.is-error {
      border-color: #f56c6c7b;
    }

    ::v-deep {
      .van-field__left-icon {
        margin-right: 8px;
      }
    }
  }

  .select-popup {
    box-sizing: border-box;
    max-height: 75vh;
    padding: 5px 14px 24px;

    .time-picker {
      ::v-deep {
        .van-picker__toolbar {
          .van-picker__confirm {
            color: #0096cc;
          }
        }

        .van-picker__columns {
          .van-picker-column {
            .van-picker-column__item--selected {
              color: #0096cc;
            }
          }
        }
      }
    }
  }

}
</style>
